import styled, { css } from 'styled-components';

import { fonts } from '@dreryk/react-components';

export const StyledMedicalLeaveFormSectionHeader = styled.h3<{ withRequiredMark?: boolean }>`
   margin: 0;
   font-weight: ${fonts.fontWeightNormal};
   font-size: 18px;

   ${(props) =>
      props.withRequiredMark &&
      css`
         &:after {
            content: '*';
            color: ${props.theme.error};
         }
      `};
`;
StyledMedicalLeaveFormSectionHeader.displayName = 'StyledMedicalLeaveFormSectionHeader';
